<template>
  <div>
    <breadcrumb>
      <template v-slot:1
        ><router-link :to="{ name: 'configuracion-carta' }">{{
          $t("configuracionCarta")
        }}</router-link></template
      >
      <template v-slot:2>{{ $t("restriccionHorarios") }}</template>
    </breadcrumb>
    <CabeceraInformes
      :idBusiness="idBusiness"
      :listBusinesses="listBusinesses"
      :idTpv="idTpv"
      :listTpv="listTpv"
      :quitarFechas="true"
      :quitarConsultas="true"
      id="cabecera"
    />

    <div class="col-md-12" v-if="respuesta && permisos">
      <div class="card">
        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
                <button class="btn btn-primary mr-3" type="button" @click="nuevaRestriccion">
                  <i class="fa fa-plus-square"></i>&nbsp;&nbsp;{{$t('nueva')}} {{$t('restriccion')}}
                </button>
            </div> 
          </div>
        </div>
        <div class="table-responsive " 
        v-if="listRestricciones.length>0 && respuesta">

          <table class="table table-bordered table-striped">
            <thead class="thead-dark">
              <tr> 
                <th class="text-center">{{$t('descripcion')}}</th>
                <th class="text-center" width="15%">{{$t('tipo')}}</th>
                <th class="text-center" width="15%">{{$t('dia')}}</th>
                <th class="text-center" width="15%">{{$t('horas')}}</th>
                <th class="text-center" width="15%">{{$t('nMaximoPedidos')}}</th>
                <!--<th class="text-center" width="15%">{{$t('horaFin')}}</th>-->
                <th class="text-center" width="15%">{{ $t("acciones") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="restriccion in listRestricciones" :key="restriccion.id">  
                <td><div v-if="restriccion.descripcion.length > 0">{{ restriccion.descripcion }}</div><div class="text-center" v-else>-</div></td>
                <td class="text-center"><div>{{ getNombreTipoRestriccion(restriccion.tipo) }}</div></td>
                <td><div class="text-center">{{ restriccion.diadelasemana | parseDiaSemana }}</div></td>
                <td><div class="text-center" v-if="restriccion.hora_inicio">{{ restriccion.hora_inicio | parseMomentMinut}} - {{ restriccion.hora_fin | parseMomentMinut}}</div><div v-else>-</div></td>
                <!--<td><div class="text-center" v-if="restriccion.hora_fin"></div><div v-else>-</div></td>-->
                <td><div class="text-center" v-if="restriccion.tipo == 'L'">{{ restriccion.num_maximo }}</div><div class="text-center" v-else>-</div></td>
                <td class="text-center">
                  <div>
                    <a @click="editarRestriccion(restriccion)" class="btn btn-danger btn-link btn-xs">
                    <i
                        class="fas fa-pencil-alt"
                        v-tooltip.top-center="$t('editar')"
                        style="color: orange"
                    ></i>
                    </a>
                    <a @click="modalBorrarRestriccion(restriccion.id)" class="btn btn-danger btn-link btn-xs">
                    <i v-tooltip.top-center="$t('borrar')"
                        class="fas fa-trash-alt text-danger"
                      ></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-danger" role="alert">
          {{$t("noHayRangosHorariosEnEsteNegocio")}}
        </div>
      </div>
    </div>
    <div class="col-md-12 ml-0" v-else>
      <div class="card" style="padding-top:30px;margin-bottom:15px;">
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              {{ $t("loSentimosParaAccederAEsteModuloNecesitaActivarLaConfiguracion") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="modalNuevoEditarRestriccion"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ getAccion }} {{$t('restriccion')}}</h4>
        </div>
        <div class="modal-body">
          <!--<input type="text" v-model="restriccion.descripcion" />-->
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("tipo") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="restriccion.tipo"
                  :placeholder="'Seleccione un tipo de restricción'"
                >
                  <el-option
                    v-for="tipo in listTipos"
                    class="select-primary"
                    :value="tipo.value"
                    :label="tipo.nombre"
                    :key="tipo.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("descripcion") }}</label>
                <el-input placeholder="Cierre del lunes por la mañana..." v-model="restriccion.descripcion"></el-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{ $t("diaDeLaSemana") }}</label>
                <el-select
                  class="select-default"
                  size="large"
                  v-model="restriccion.diadelasemana"
                  filterable
                  :placeholder="$t('seleccioneDiaDeLaSemana')"
                >
                  <el-option
                    v-for="dia in listDias"
                    class="select-primary"
                    :value="dia.value"
                    :label="dia.dia"
                    :key="dia.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ $t("horaInicio") }}</label>
                  <datetime
                    value-zone="Europe/Madrid"
                    :auto="true"
                    type="time"
                    class="theme-numier"
                    :title="$t('horaInicio')"
                    :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                    input-class="form-control"
                    format="HH:mm"
                    v-model="restriccion.hora_inicio"
                  ></datetime>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ $t("horaFin") }}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  type="time"
                  class="theme-numier"
                  :title="$t('horaFin')"
                  :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
                  input-class="form-control"
                  format="HH:mm"
                  v-model="restriccion.hora_fin"
                ></datetime>
              </div>
            </div>
          </div>
          <div class="row" v-if="restriccion.tipo == 'L'">
            <div class="col-md-5">
              <div class="form-group">
                <label>{{ $t('numeroPedidosPermitidos') }}</label>
                <el-input-number v-model="restriccion.num_maximo" :min="1" :max="50"></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-danger"
            @click="$modal.hide('modalNuevoEditarRestriccion')"
          >
            <i class="fa fa-times-circle"></i> {{ $t("cancelar") }}
          </button>
          <button class="btn btn-primary" @click="modalConfirmation">
            <i class="fa fa-check-circle"></i>
            {{ $t("guardar") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import swal from "sweetalert2";
import { Loading, Select, Option } from "element-ui";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "../../../../../components/CabeceraInformes/CabeceraInformes.vue";
export default {
  name: "RestriccionHorarios",
  components: {
    Breadcrumb,
    CabeceraInformes,
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      idBusiness: 0,
      idTpv: 0,
      listTpv: [],
      listBusinesses: [],
      listRestricciones: [],
      accion: 0,
      respuesta: false,
      permisos: false,
      idBusinessInfo: 0,
      restriccion: {
        id: 0,
        descripcion: "",
        tipo: 'CF',
        diadelasemana: 1,
        hora_inicio: "2020-11-17T12:00:00.000+01:00",
        hora_fin: "2020-11-17T14:00:00.000+01:00",
        num_maximo: 0
      },
      listDias: [
        { value: 1, dia: "Todos los lunes" },
        { value: 2, dia: "Todos los martes" },
        { value: 3, dia: "Todos los miércoles" },
        { value: 4, dia: "Todos los jueves" },
        { value: 5, dia: "Todos los viernes" },
        { value: 6, dia: "Todos los sábados" },
        { value: 7, dia: "Todos los domingos" },
      ],
      listTipos: [
        { value: 'CF', nombre: this.$t('cerrarFranja')},
        { value: 'L', nombre: this.$t('limitePedidos')},
        //{ value: 2, nombre: "Todos los días"},
        //{ value: 3, nombre: "Ejemplo"}
      ]
    };
  },
  computed: {
    getAccion() {
      return this.restriccion.id == -1 ? "Nueva" : "Editar";
    },
    hora_inicio() {
      return this.restriccion.hora_inicio;
    },
    hora_fin() {
      return this.restriccion.hora_fin;
    }
  },
  watch: {
    hora_inicio() {
      setTimeout(() => this.checkHoras("inicio"), 100);
    },
    hora_fin() {
      setTimeout(() => this.checkHoras("fin"), 100);
    },
  },
  methods: {
    getNombreTipoRestriccion(tipo) {
      const tip = this.listTipos.find(el=>{
            return el.value==tipo
        })
        return tip?tip.nombre:''
    },
    nuevaRestriccion() {
      this.restriccion = {
        id: -1,
        descripcion: "",
        diadelasemana: 1,
        tipo: 'CF',
        hora_inicio: "2020-11-17T12:00:00.000+01:00",
        hora_fin: "2020-11-17T14:00:00.000+01:00",
        num_maximo: 1
      };
      this.$modal.show("modalNuevoEditarRestriccion");
    },
    getTipoRestriccion(reTipo) {
      this.listTipos.forEach(tipo => {
        if (tipo.value == reTipo) {
          return tipo.nombre;
        }
      });
    },
    comprobarConfiguracion() {
      let vm = this;
      //horariosSelect
      let idConfigHorarioSelect = 46;

      //Preparo la petición
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idConfig: idConfigHorarioSelect,
          idTpv: this.idTpv
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      //Mando la petición
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfig", config)
        .then(function(response) {
          vm.inProgress = false;

          if (response.data.response) {
            
            if (response.data.result){
              vm.permisos = true;
              vm.loading.close();
            } else {
              vm.permisos = false;
              vm.comprobarConfiguracionPorSemana();
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    comprobarConfiguracionPorSemana() {
      let vm = this;
      //horarioPorSemana
      let idConfigHorarioSelect = 56;

      //Preparo la petición
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idConfig: idConfigHorarioSelect,
          idTpv: this.idTpv
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      //Mando la petición
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfig", config)
        .then(function(response) {
          vm.inProgress = false;

          if (response.data.response) {
            
            if (response.data.result){
              vm.permisos = true;
              vm.loading.close();
            } else {
              vm.comprobarConfiguracionCruzcampo();
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    comprobarConfiguracionCruzcampo() {
      let vm = this;
      //horariosSelect
      let idConfigHorarioSelect = 57;

      //Preparo la petición
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
          idConfig: idConfigHorarioSelect,
          idTpv: this.idTpv
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      //Mando la petición
      this.axios
        .get(this.$store.getters.apiUrl + "general/checkConfig", config)
        .then(function(response) {
          vm.inProgress = false;

          if (response.data.response) {
            
            if (response.data.result){
              vm.permisos = true;
            }

          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("error"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        }).finally((_) => {
          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    checkHoras(horaCambiada) {
      let fechaDesHours = moment(this.restriccion.hora_inicio).format("HH:mm:ss");
      let fechaHastHours = moment(this.restriccion.hora_fin).format("HH:mm:ss");

      if (fechaDesHours > fechaHastHours) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("laHoraInicioNoPuedeSerMayorQueLaHoraFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
        // console.log(horaCambiada);
        if (horaCambiada == "inicio") {
          this.restriccion.hora_inicio = "2020-11-17T12:00:00.000+01:00";
        } else {
          this.restriccion.hora_fin = "2020-11-17T14:00:00.000+01:00";
        }
      }
    },
    modalConfirmation() {
      if (this.restriccion.tipo != 'L') {
        this.restriccion.num_maximo = 0;
      }
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        restriccion: this.restriccion,
        idTpv: this.idTpv,
        idBusinessInfo: this.idBusinessInfo,
        jwt: this.$store.getters.jwt,
      };
      let vm = this;
      let controller = "createUpdateRestriccionHorario";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.getRestriccionesByTpv();

            vm.$modal.hide("modalNuevoEditarRestriccion");

            if (vm.restriccion.id != -1) {
              vm.$notify({
                message:
                  vm.$t("restriccion") + ' ' +
                  vm.$t("editada")+ ' ' +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              vm.$notify({
                message:
                  vm.$t("restriccion") + ' ' +
                  vm.$t("creada")+ ' ' +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    editarRestriccion(restriccion) {
      this.restriccion = { ...restriccion };
      this.restriccion.diadelasemana = parseInt(restriccion.diadelasemana);
      this.$modal.show("modalNuevoEditarRestriccion");
    },
    modalBorrarRestriccion(id) {

      swal({
          title: this.$t('estaSeguroDeQueDeseaEliminarEstaRestriccion'),
          text: this.$t('estaOperacionNoSePuedeDeshacer'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: this.$t('siBorrarRestriccion'),
          cancelButtonText: this.$t('cancelar'),
          buttonsStyling: true
      }).then((result) => {
          if (result.value) {

              this.borrarRestriccion(id);

          }
      });

    },
    borrarRestriccion(id) {
      /*this.listRestricciones = this.listRestricciones.filter((el) => {
        return el != restriccion;
      });*/
      //TODO borrar en BD
      // console.log(this.$store.getters.jwt);
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      
      var params = {
        id: id,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios
        .post(this.$store.getters.apiUrl + "delivery/deleteRestriccionById", params, config)
        .then(function(response) {
          if (response.data.response) {

            vm.$notify({
              message:
                vm.$t("restriccion") +
                " "+
                vm.$t("eliminada") +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.getRestriccionesByTpv();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;
          vm.getTpv();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getRestriccionesByTpv() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getRestriccionesByTpv",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listRestricciones = response.data.result;
            vm.respuesta = true;
          }
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    getBusinessInfo() {
      var config = {
        params: {
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getIdBusinessInfoByIdTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.idBusinessInfo = response.data.result;

          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("esteNegocioNoTieneCarta"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
            vm.newButton = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
              vm.getBusinessInfo();
              vm.comprobarConfiguracion();
              vm.getRestriccionesByTpv();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          //vm.loading.close();
        });
    },
    cambioBusiness(idBusinessData, listTpv) {
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = 0;
      this.listaAreas = [];
      this.getTpv();
    },
    emitirConsulta() {},
    cambioTpv(idTpvData) {
      this.idTpv = idTpvData;
      this.listaAreas = [];
    },
    cambioHora(dates) {},
  },
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.getBusiness();
  },
}
</script>
<style scoped>
    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Horarios/RestriccionHorarios.vue